<template>
  <div class="advisorDialog">
    <popup v-if="activated">
      <template #title>추천인 검색</template>

      <template #content>
        <div class="selectBox" style="margin-top:10px;margin-bottom: 10px">
          <div class="wrapInp">
            <input type="text"
                   style="ime-mode:active"
                   v-model="searchAdvisorName"
                   @focusin="focusedSearchBox=true"
                   @focusout="focusedSearchBox=false"
                   v-on:keyup.enter="search(searchAdvisorName)"
            >
          </div>
          <button type="button" class="advisorSearchButton btnSearch"
                  @click="search(searchAdvisorName)"
          />

          <div v-if="searchAdvisors.length && (focusedSearchRecommender || focusedSearchBox)"
               tabindex="9999"
               id="searchRecommender" ref="searchRecommender" class="searchRecommender"
               @mousedown="$refs.searchRecommender.focus()"
               @focusin="focusedSearchRecommender=true"
               @focusout="focusedSearchRecommender=false"
          >
            <ul v-for="(item) in searchAdvisors" :key="item.id">
              <li @click="selectAdvisor(item)" v-html="item.recommendTitle"/>
            </ul>
          </div>
        </div>

        <div class="tglWrap">
          <ul>
            <li :class="`tgl mt1`">
              <div type="button" style="padding-right: 10px" class="tglTtl noneAdvisor">
                <input type="radio"
                       id="agent-0" ref="agent-0" name="advisor"
                       v-model="advisor"
                       :value="{id:null, title:'추천인 선택 안함'}"
                />
                <label style="padding-left: unset;" for="agent-0">
                  <span style="margin-left: unset; font-weight:bold; font-size:15px;">추천인 선택 안함</span>
                </label>
              </div>
            </li>

            <li :class="`tgl mt1`" id="dealerList">
              <span type="button" class="tglTtl">
                딜러 : {{ dealer.title }}
              </span>
            </li>

            <li :class="`tgl mt1 ${activatedAgent}`" id="agentList">
              <button type="button" class="tglBtn" @click="activeAgent()"> 서비스 센터</button>
              <span class="shortDesc">{{agentTitle}}</span>
              <div class="tglCon" >
                <span style="color: #fe811e;"></span>
                <template>
                  <ul>
                    <li v-for="(item) in agents" :key="item.id" style="padding: 5px 0">
                      <input type="radio" name="agent"
                             v-model="agent"
                             :value="item"
                             :id="`agent-${item.id}`"
                             :ref="`agent-${item.id}`"
                      />
                      <label style="padding-left: 0; font-size:15px" :for="`agent-${item.id}`">
                        <span style="calc(100% - 40px)">{{ item.title }}</span>
                      </label>
                    </li>
                  </ul>
                </template>
              </div>
            </li>

            <li :class="`tgl mt1 ${activatedAdvisor}`" id="advisorList">
              <button type="button" class="tglBtn" @click="activeAdvisor()">어드바이저</button>
              <span class="shortDesc">{{advisorTitle}}</span>
              <div class="tglCon" >
                <span style="color: #fe811e;"></span>
                <template>
                  <ul v-if="advisors.length">
                    <li v-for="(item) in advisors" :key="item.id" style="padding: 5px 0">
                      <input type="radio"  name="advisor"
                             v-model="advisor"
                             :value="item"
                             :id="`advisor-${item.id}`"
                      />
                      <label style="padding-left: 0; font-size: 15px" :for="`advisor-${item.id}`">
                        <span style="width: calc(100% - 40px)">
                          {{ item.title }}
                        </span>
                      </label>
                    </li>
                  </ul>

                  <ul v-else>
                    <li  style="padding: 5px 0"><span>검색된 어드바이저가 없습니다.</span></li>
                  </ul>
                </template>
              </div>
            </li>

          </ul>
        </div>

      </template>

      <template #button>
        <span><a @click="closePopup(false)">취소</a></span>
        <span><a @click="closePopup(true)" class="fCol1">확인</a></span>
      </template>
    </popup>

    <popup-alert v-if="activatedAlert" title="알림" @close="activatedAlert=false">
      <popup-msg :type="activatedAlertMsg"></popup-msg>
    </popup-alert>

  </div>
</template>


<script>
import axios from "axios";
import {api} from "../../../../api";

import Popup from "../../../../components/Popup/Popup";
import PopupAlert from '../../../../components/Popup/PopupAlert.vue';
import PopupMsg from '../../../../components/Popup/PopupMsgTemplate';
import SelectInput from "../../../../components/Input/SelectInput";

export default {
  components: {
    Popup,
    PopupAlert,
    PopupMsg,
    SelectInput
  },

  methods: {
    closePopup(ok) {
      if (ok && this.advisor) {
        this.$emit("ok", this.advisor, this.advisor.title);
      } else if (ok && !this.advisor) {
        this.activatedAlert = true;
        this.activatedAlertMsg = 'SUBSC_REQ_ADVISOR';
      } else {
        this.$emit("cancel");
      }
    },

    activeAgent(activated) {
      this.activatedAgent = this.activatedAgent === 'on' ? '' : 'on';
      this.activatedAdvisor = 'off';
      if (activated !== undefined) this.activatedAgent = activated;
    },

    activeAdvisor(activated) {
      this.activatedAgent = 'off';
      this.activatedAdvisor = this.activatedAdvisor === 'on' ? '' : 'on';
      if (activated !== undefined) this.activatedAdvisor = activated;
    },

    getDealerAgentCdks() {
      this.advisorName = null;
      this.searchAdvisorName = null;

      let filter = {
        "dealer": {
          "key": "dealer_cdk_id",
          "val": this.dealer.id
        },
        'has_advisors': true,
        "orders": {"key": "title", "val": true}
      };
      filter = encodeURI(JSON.stringify(filter));
      axios.get(`${api.dealerAgentCdks}?filters=${filter}&limit=999`)
          .then(({data}) => {
            this.advisors = [];
            this.agents = data.data;
            this.activeAgent('on');
          })
          .catch(() => {
            // this.activateMsg = `[${response.status}] 딜러사 지점 리스트를 불러오지 못했습니다.`;
            // this.activate = true;
          })
    },

    getDealerAdvisorCdks(option) {
      option = Object.assign({agent: null, advisorName: null}, option)
      let filter = {};

      filter["orders"] = {"key": "name", "val": "asc"}
      filter["used"] = {"key": "used", "val": true}

      if (option.agent !== null) {
        filter['agents'] = {
          "key": "typeable_id",
          "val": [option.agent.id],
        };
      } else if (option.advisorName !== null) {
        filter['search'] = {
          "key": "name",
          "val": option.advisorName,
        };
        filter['agents'] = {
          "key": "typeable_id",
          "val": [],
        };
        this.agents.forEach(agent=>{filter.agents.val.push(agent.id)})
      } else {
        filter = null;
      }
      option.limit = option.limit || '';

      return new Promise((resolve, reject) => {
        if (filter === null) {
          resolve([]);
          return;
        }

        filter = encodeURI(JSON.stringify(filter));
        axios.get(`${api.dealerAdvisorCdks}?filters=${filter}&limit=${option.limit}`)
            .then(({data}) => {
              data.data.forEach(item => {
                item.title = `${item.name} - ${item.dealer_agent_cdk.dealer_cdk.title} ${item.dealer_agent_cdk.title} 서비스 센터`
              });
              resolve(data.data);
            })
            .catch((...e) => {
              reject(...e);
            });
      });
    },

    search(advisorName) {
      this.advisor = null;
      this.agent = null;
      this.searchAdvisorName = advisorName;

      return new Promise((resolve, reject) => {
        this.getDealerAdvisorCdks({advisorName: advisorName, limit:8})
            .then((advisors) => {
              this.advisors = advisors;
              this.activeAdvisor('on');
              resolve(advisors);
            }).catch((...e) => {
          reject(...e);
        })
      });
    },

    selectAdvisor(advisor){
      this.advisors = [advisor];
      this.advisor = advisor;
      this.activeAdvisor('on');
    },
  },


  create() {
    this.activated = false;
    this.dealer = null;
    this.agent = null;
    this.advisor = null;
  },


  props: {
    activated: Boolean,
    dealer: {id: null, title: null},
  },


  data() {
    return {
      dealers: [],
      agents: [],
      advisors: [],
      searchAdvisors: [],

      searchAdvisorName: null,
      lastSearchAdvisorName: null,
      searchAgentSlug: null,
      activatedSearch: false,
      focusedSearchBox: false,
      focusedSearchRecommender: false,
      blockedAdviserUpdate: false,

      activatedAgent: 'off',
      activatedAdvisor: 'off',


      agent: {id: null, slug: null, title: null},
      advisor: {
        id: null, name: null,
        dealer_cdk: {id: null, title: null},
        dealer_agent_cdk_slug: null,
        dealer_agent_cdk: {id: null, slug: null, title: null},
      },
      agentTitle: null,
      advisorTitle: null,

      activatedAlert: false,
      activatedAlertMsg: null,
    }
  },

  watch: {
    dealer: function (val) {
      this.dealer = val;
      this.agent = null;
      this.advisor = null;
      this.getDealerAgentCdks();
    },

    searchAdvisorName: function (val) {
      this.searchAdvisorName = val;

      val = val || '';
      if (val === '') {
        this.lastSearchAdvisorName = null;
        this.searchAdvisors = [];
        return;
      }

      // noinspection JSCheckFunctionSignatures
      let advisorName = val.matchAll('([가-힣a-zA-Z0-9_-]+)').next().value;
      if (advisorName !== undefined) advisorName = advisorName[0];
      let option = {advisorName: advisorName, limit: 8};
      if (advisorName === this.lastSearchAdvisorName) return;
      if (this.lastSearchAdvisorName === advisorName) return;

      this.getDealerAdvisorCdks(option)
          .then((advisors) => {
            advisors.sort((a, b) => a.name.indexOf(advisorName) - b.name.indexOf(advisorName));
            advisors.forEach(item => {
              item.title = `${item.dealer_agent_cdk.dealer_cdk.title} ${item.dealer_agent_cdk.title} 서비스 센터`;
              item.recommendTitle = item.name.replaceAll(
                  advisorName,
                  `<span style="color:blue; font-weight:bold">${advisorName}</span>`
              );
              item.recommendTitle = `${item.recommendTitle} - ${item.title}`;
              item.title = `${item.name} - ${item.title}`;
            });
            this.searchAdvisors = advisors;
          });

      this.lastSearchAdvisorName = advisorName;
    },

    agent: function (agent) {
      this.agents.forEach((item) => {
        let agentEl = this.$refs[`agent-${item.id}`];
        if (agentEl) agentEl.forEach((item) => item.checked = false);
      })

      if (agent === null) {
        this.agentTitle = '선택해 주세요.';
      } else {
        let agentEl = this.$refs[`agent-${agent.id}`];
        if (agentEl) agentEl.forEach((item) => item.checked = true);

        this.agentTitle = this.agent.title + ' 서비스 센터';

        // noinspection JSIncompatibleTypesComparison
        if (
            this.advisor === null || this.advisor.id === null
            || agent.id !== this.advisor.dealer_agent_cdk.id
        ) {
          this.advisor = null;
          this.searchAdvisorName = null;
          this.getDealerAdvisorCdks({agent: this.agent})
              .then((advisors) => {
                this.advisors = advisors;
                this.activeAdvisor('on');
              })
        }
      }
    },

    advisor: function (advisor) {
      if (advisor === null) {
        this.advisorTitle = '선택해 주세요.';
      } else if (advisor.id == null) {
        this.agent = null;
        this.advisorTitle = '선택 안함';
      } else {
        this.advisorTitle = this.advisor.name;
        this.agent = advisor.dealer_agent_cdk;
      }
      this.focusedSearchRecommender = false;
    },
  }
}
</script>


<style>
.advisorDialog .shortDesc{
  margin-top: -39px;
  position: absolute;
  right: 50px;
}

.advisorDialog .searchRecommender {
  border: 1px solid #aaa;
  border-top: 1px solid #333;
  border-radius: 4px;
  position: absolute;
  background: #fff;
  z-index: 99999;
  width: 100%;
  padding: 8px 15px;
}

.advisorDialog .searchRecommender li {
  padding:8px 0;
}

.advisorDialog  label{
  width: 100%;
}
.advisorDialog input[type=radio] {
  display: none;
}

.advisorDialog input[type=radio]+label:before{
  left: unset;
  right: 0;
}

/* 추천인 검색 버튼  */
.advisorDialog .advisorSearchButton{
  margin-top: -39px;
  position: absolute;
  right: 6px;
  width: 32px;
  height: 32px;
}
</style>